module.exports = __webpack_public_path__ + "static/media/icon-remove.7284a61c.svg";